const SIZE_FILTER = 'filter.v.option.taille',
      AVAILABILITY_FILTER = 'filter.v.availability';

class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.filters = this.querySelectorAll('input[type="radio"]');
    this.collectionHandle = this.dataset.collection;

    this.setEventListeners();
  }

  setEventListeners() {
    this.filters.forEach((filter) => {
      filter.addEventListener('click', (e) => {
        this.loadContent(e.target);
      });
    })
  }

  loadContent(input) {
    const filters = `${SIZE_FILTER}=${input.value.replace('/', '%2F')}&${AVAILABILITY_FILTER}=1`,
          updatedFilters = window.location.href.indexOf(filters) > -1 ? '' : filters,
          divider = updatedFilters == '' ? '' : '&',
          path = `/collections/${this.collectionHandle}?section_id=main-collection${divider}${updatedFilters}`,
          container = document.querySelector('.collection-grid'),
          loadingClass = 'loading';

    container.classList.add(loadingClass);

    fetch(path)
      .then((response) => {
        if (!response.ok) {
          console.log(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const htmlObject = document.createElement('div');

        htmlObject.innerHTML = text;
        if (htmlObject.querySelector('.collection-grid') !== null) {
          container.innerHTML = htmlObject.querySelector('.collection-grid').innerHTML;
          container.classList.remove(loadingClass);

          this.updatePath(updatedFilters);
          this.updateTitle();

          if (updatedFilters == '') input.checked = false;
        }
      })
  }

  updateTitle() {
    this.filters.forEach((input) => {
      const inputLabel = document.querySelector(`label[for="${input.id}"]`);

      inputLabel.title = input.checked ? window.tokens.filter_remove : window.tokens.filter_add;
    })
  }

  updatePath(newPath) {
    const updatedPath = `/collections/${this.collectionHandle}${newPath == '' ? '' : '?'}${newPath}`;

    window.history.pushState(null, null, updatedPath);
  }
}

customElements.define('collection-filters', CollectionFilters);
